import React, { Component } from 'react';
import { ConvertEthnic, ConvertOccupation, formatVietnameseDate, isValidDate, renderRank, renderRankHtml } from '@/utils/helpers';
import moment from 'moment';

class PrintCustomerProfile extends Component {

    render() {
        const { customer, data } = this.props;

        //console.log('data', data);

        const phone_numbers = customer?.phone_numbers || [];

        const ly_do_vao_vien = data?.ly_do_vao_vien || '';
        const hoi_benh = data?.hoi_benh || '';
        const tien_su_benh_lien_quan = data?.tien_su_benh_lien_quan || [];
        const mach = data?.mach || '';
        const nhiet_do = data?.nhiet_do || '';
        const huyet_ap = data?.huyet_ap || '';
        const nhip_tho = data?.nhip_tho || '';
        const can_nang = data?.can_nang || '';
        const chieu_cao = data?.chieu_cao || '';
        const toan_than = data?.toan_than || [];
        const kham_chuyen_khoa = data?.kham_chuyen_khoa || [];
        const cac_xet_nghiem_can_lam = data?.cac_xet_nghiem_can_lam || [];
        const tom_tat_benh_an = data?.tom_tat_benh_an || '';
        const benh_chinh = data?.benh_chinh || '';
        const benh_chinh_code = data?.benh_chinh_code || '';
        const benh_kem_theo = data?.benh_kem_theo || '';
        const benh_kem_theo_code = data?.benh_kem_theo_code || '';
        const bien_chung = data?.bien_chung || '';
        const bien_chung_code = data?.bien_chung_code || '';
        const ke_hoach_dieu_tri = data?.ke_hoach_dieu_tri || '';
        const qua_trinh_dieu_tri = data?.qua_trinh_dieu_tri || [];
        const thoi_gian_dieu_tri_start = data?.thoi_gian_dieu_tri_start || '';
        const thoi_gian_dieu_tri_end = data?.thoi_gian_dieu_tri_end || '';
        const tom_tat_qua_trinh_benh_ly = data?.tom_tat_qua_trinh_benh_ly || '';
        const dau_hieu_lam_sang = data?.dau_hieu_lam_sang || '';
        const tom_tat_ket_qua_xet_nghiem = data?.tom_tat_ket_qua_xet_nghiem || '';
        const phuong_phap_dieu_tri = data?.phuong_phap_dieu_tri || [];
        const tinh_trang_ra_vien = data?.tinh_trang_ra_vien || '';
        const huong_dieu_tri_tiep_theo = data?.huong_dieu_tri_tiep_theo || '';

        const created_at = data?.created_at || '';
        const doctor = data?.doctor?.full_name || '';

        const addressParts = [
            customer?.address?.trim(),
            customer?.hamlet?.trim(),
            customer?.wards_name?.trim(),
            customer?.province_name?.trim(),
        ];

        // Lọc bỏ phần rỗng hoặc undefined, rồi nối bằng dấu phẩy
        const address = addressParts.filter(Boolean).join(', ') || '-';

        const PrintCheckbox = ({ label, value, current, style }) => (
            <>
                <span
                    className={`checkbox ${current === value ? 'checked' : ''}`}
                    style={style}
                ></span>
                {label}
            </>
        );

        return (
            <div className='print-container'>
                <div className="print-page">
                    {/* HEADER CẬP NHẬT */}
                    <div className="header">
                        <div className="header-left">
                            Công ty TNHH Anh Nguyễn Beauty
                            <br />
                            Cơ sở KB, CB: Nha khoa CHINGO
                        </div>
                        <div className="header-center">
                            <h1 className="title">
                                BỆNH ÁN NGOẠI TRÚ
                                <br />
                                RĂNG HÀM MẶT
                            </h1>
                        </div>
                        <div className="header-right">MS: BA-18</div>
                    </div>
                    <h3>A. THÔNG TIN CHUNG</h3>
                    <div className="section">
                        <div className="info-item">
                            <span className="label">
                                1. Họ và tên <span className="text-italic">(In hoa)</span>:
                            </span>
                            <span className="text-uppercase"><strong>{customer?.full_name}</strong></span>
                        </div>
                        <div className="info-grid">
                            {/* CỘT TRÁI */}
                            <div className="col">
                                <div className="info-item">
                                    <span className="label">2. Ngày sinh:</span>
                                    <span>{isValidDate(customer?.birthday, false)}</span>
                                    &nbsp;Tuổi:&nbsp;<span>{customer?.age}</span>
                                </div>
                                <div className="info-item">
                                    <span className="label">4. Điện thoại:</span>
                                    <span>{phone_numbers.join(', ')}</span>
                                </div>
                                <div className="info-item">
                                    <span className="label">6. Dân tộc:</span>
                                    <span>{ConvertEthnic(customer?.ethnicity)}</span>
                                </div>
                            </div>
                            {/* CỘT PHẢI */}
                            <div className="col">
                                <div className="info-item">
                                    <span className="label">3. Giới tính:</span>
                                    <PrintCheckbox label="Nam" value="nam" current={customer?.gender} style={{ marginLeft: 0 }} />
                                    <PrintCheckbox label="Nữ" value="nu" current={customer?.gender} />
                                </div>
                                <div className="info-item">
                                    <span className="label">5. Nghề nghiệp:</span>
                                    <span style={{ width: "45mm" }}>{ConvertOccupation(customer?.occupation)}</span>
                                </div>
                                <div className="info-item">
                                    <span className="label">7. Quốc tịch:</span>
                                    <span style={{ width: "25mm" }}>{customer?.nationality}</span>
                                </div>
                            </div>
                        </div>
                        <div className="info-item">
                            <span className="label">8. Địa chỉ:</span>
                            <span>{address}</span>
                        </div>
                        <div className="info-item">
                            <div className="info-item">
                                <span className="label">9. Đối tượng:</span>
                                <PrintCheckbox label="BHYT" value="bhyt" current={customer?.customer_type} style={{ marginLeft: 0 }} />
                                <PrintCheckbox label="Thu phí" value="thuphi" current={customer?.customer_type} />
                                <PrintCheckbox label="Miễn" value="mienphi" current={customer?.customer_type} />
                                <PrintCheckbox label="Khác" value="khac" current={customer?.customer_type} />
                            </div>
                        </div>

                        <div className="info-item">
                            <span className="label">10. Số thẻ BHYT:</span>
                            <span> {customer?.bhyt_number}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">
                                11. Số Căn cước/Hộ chiếu/Số định danh cá nhân:
                            </span>
                            <span> {customer?.identity_number}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">
                                12. Họ và tên thân nhân của NB khi cần báo tin:
                            </span>
                            <span> {customer?.relative_info}</span>
                            <span>&nbsp;-&nbsp;Điện thoại: {customer?.relative_info_phone}</span>
                        </div>
                    </div>
                    <h3>B. THÔNG TIN KHÁM BỆNH</h3>
                    <div className="section">
                        <b>I. LÝ DO VÀO VIỆN, VẤN ĐỀ SỨC KHỎE:</b>
                        <div>{ly_do_vao_vien}</div>
                    </div>
                    <div className="section">
                        <b>II. HỎI BỆNH</b>
                        <br />
                        <div>
                            <b>1. Quá trình bệnh lý và diễn biến lâm sàng:</b>
                            <span className="text-italic">
                                (Đặc điểm khởi phát, các triệu chứng lâm sàng, diễn biến bệnh...)
                            </span>
                        </div>
                        <div className="mb-1">{hoi_benh}</div>
                        <div>
                            <span className="label">
                                <b>2. Tiền sử có liên quan đến tình trạng bệnh lần này:</b>
                            </span>
                            <br />
                            <div className='mb-4' dangerouslySetInnerHTML={{
                                __html: renderRankHtml(tien_su_benh_lien_quan),
                            }} />
                        </div>
                    </div>
                    <div className="section">
                        <b>III. KHÁM BỆNH</b>
                        <br />
                        <div className="mb-2">
                            <div className="exam-section">
                                {/* Cột trái */}
                                <div>
                                    <span className="display-inline mr-1">
                                        <b>1. Toàn thân: </b>
                                    </span>
                                    {renderRank(toan_than)}
                                </div>
                                {/* Cột phải (Khung sinh hiệu) */}
                                <div className="vitals">
                                    <p>
                                        <span className="vitals-label">Mạch:</span> {mach || '.......'} lần/phút
                                    </p>
                                    <p>
                                        <span className="vitals-label">Nhiệt độ:</span> {nhiet_do || '.......'} °C
                                    </p>
                                    <p>
                                        <span className="vitals-label">Huyết áp:</span> {huyet_ap || '....... / .......'} mmHg
                                    </p>
                                    <p>
                                        <span className="vitals-label">Nhịp thở:</span> {nhip_tho || '.......'} lần/phút
                                    </p>
                                    <p>
                                        <span className="vitals-label">Cân nặng:</span> {can_nang || '.......'} kg
                                    </p>
                                    <p>
                                        <span className="vitals-label">Chiều cao:</span> {chieu_cao || '.......'} cm
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="mb-2">
                            <span className="label">
                                <b>2. Khám chuyên khoa</b>
                            </span>
                            <div className='mb-4' dangerouslySetInnerHTML={{
                                __html: renderRankHtml(kham_chuyen_khoa),
                            }} />
                        </div>
                        <div className="mb-2">
                            <span className="display-inline mr-1">
                                <b>3. Các xét nghiệm, cận lâm sàng cần làm:</b>
                            </span>
                            {renderRank(cac_xet_nghiem_can_lam)}
                        </div>
                        <div className="mb-2">
                            <span className="display-inline">
                                <b>4. Tóm tắt bệnh án:</b>
                            </span>
                            {tom_tat_benh_an}
                        </div>
                    </div>
                    <b>IV. CHẨN ĐOÁN (Tên bệnh kèm theo mã ICD)</b>
                    <br />
                    <strong>Bệnh chính:</strong>
                    {benh_chinh ? (
                        <>{benh_chinh} (Mã ICD: {benh_chinh_code})</>
                    ) : (<>...................................................................................Mã ICD:.......................</>)}

                    <br />
                    <strong>Bệnh kèm theo (nếu có):</strong>
                    {benh_kem_theo ? (
                        <>{benh_kem_theo} (Mã ICD: {benh_kem_theo_code})</>
                    ) : (<>...................................................................................Mã ICD:.......................</>)}
                    <br />
                    <strong>Biến chứng (nếu có):</strong>
                    {bien_chung ? (
                        <>{bien_chung} (Mã ICD: {bien_chung_code})</>
                    ) : (<>...................................................................................Mã ICD:.......................</>)}

                    <h3 style={{ marginTop: "6mm" }}>V. KẾ HOẠCH ĐIỀU TRỊ</h3>
                    <div>{ke_hoach_dieu_tri}</div>

                    <h3 style={{ marginTop: "4mm" }}>VI. QUÁ TRÌNH ĐIỀU TRỊ </h3>
                    <table className="tb">
                        <tbody>
                            <tr>
                                <th>Ngày</th>
                                <th>Diễn biến bệnh</th>
                                <th>Xử trí</th>
                                <th>Ghi chú</th>
                            </tr>

                            {(qua_trinh_dieu_tri?.length > 0 ? (
                                qua_trinh_dieu_tri.map((item, i) => (
                                    <tr key={i} style={{ textAlign: 'left' }}>
                                        <td>{isValidDate(item.ngay, false)}</td>
                                        <td>{item.dien_bien_benh}</td>
                                        <td>{item.xu_tri}</td>
                                        <td>{item.note}</td>
                                    </tr>
                                ))
                            ) : (
                                Array.from({ length: 4 }).map((_, i) => (
                                    <tr key={i}>
                                        <td>&nbsp;</td>
                                        <td />
                                        <td />
                                        <td />
                                    </tr>
                                ))
                            ))}
                        </tbody>
                    </table>

                    <h3 style={{ marginTop: "5mm" }}>VII. THỜI GIAN ĐIỀU TRỊ</h3>
                    {thoi_gian_dieu_tri_start && thoi_gian_dieu_tri_end ? (
                        <>Điều trị từ ngày {isValidDate(thoi_gian_dieu_tri_start, false)} đến ngày {isValidDate(thoi_gian_dieu_tri_end, false)}</>
                    ) : (
                        <>Điều trị từ ngày ...../...../20..... đến ngày ...../...../20.....</>
                    )}

                    <br />
                    {/* PHẦN CHỮ KÝ */}
                    <div className="signature-section">
                        <div className="signature-col">
                            {/* <div className="date-line">Ngày ..... tháng ..... năm 20.....</div> */}
                            <div className='date-line'>Ngày {formatVietnameseDate(moment().format('DD/MM/YYYY'))}</div>
                            <div className="sign-label">Bác sĩ điều trị</div>
                            <div className="sign-note">(Ký, ghi rõ họ tên)</div>
                        </div>
                        <div className="signature-col">
                            {/* <div className="date-line">Ngày ..... tháng ..... năm 20.....</div> */}
                            <div className='date-line'>Ngày {formatVietnameseDate(moment().format('DD/MM/YYYY'))}</div>
                            <div className="sign-label">Đại diện cơ sở KB, CB</div>
                            <div className="sign-note">(Ký, đóng dấu)</div>
                        </div>
                    </div>
                </div>
                {/* ================= TRANG 3 ================= */}
                <div className="print-page">
                    <h3>C. TỔNG KẾT BỆNH ÁN</h3>
                    <div><strong>1. Tóm tắt quá trình bệnh lý và diễn biến lâm sàng</strong> <span style={{ fontStyle: 'italic' }}>(Đặc điểm khởi phát, các triệu chứng lâm sàng, diễn biến bệnh...): </span></div>
                    {tom_tat_qua_trinh_benh_ly ? (
                        <div className='mb-4'>{tom_tat_qua_trinh_benh_ly}</div>
                    ) : (
                        <>
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line mb-4' />
                        </>
                    )}


                    <div><strong>2. Những dấu hiệu lâm sàng chính được ghi nhận</strong> <span style={{ fontStyle: 'italic' }}>(có giá trị chẩn đoán trong quá trình điều trị): </span></div>
                    {dau_hieu_lam_sang ? (
                        <div className='mb-4'>{dau_hieu_lam_sang}</div>
                    ) : (
                        <>
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line mb-4' />
                        </>
                    )}

                    <div><strong>3. Tóm tắt kết quả xét nghiệm, cận lâm sàng có giá trị chẩn đoán: </strong></div>
                    {tom_tat_ket_qua_xet_nghiem ? (
                        <div className='mb-4'>{tom_tat_ket_qua_xet_nghiem}</div>
                    ) : (
                        <>
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line mb-4' />
                        </>
                    )}

                    <div><strong>4. Phương pháp điều trị (tương ứng với chẩn đoán): </strong></div>
                    <div className='mb-4' dangerouslySetInnerHTML={{
                        __html: renderRankHtml(phuong_phap_dieu_tri),
                    }} />

                    <div><strong>5. Tình trạng ra viện</strong></div>
                    {/* {tinh_trang_ra_vien && tinh_trang_ra_vien.length > 0 && <div className="mb-4">{tinh_trang_ra_vien.join(', ')}</div>} */}
                    <div className="info-item mb-4">
                        {[
                            "Khỏi",
                            "Đỡ",
                            "Không thay đổi",
                            "Nặng hơn",
                            "Tử vong",
                            "Tiên lượng nặng xin về",
                            "Chưa xác định"
                        ].map((label, i) => (
                            <React.Fragment key={i}>
                                <span
                                    className={`checkbox ${tinh_trang_ra_vien?.includes(label) ? "checked" : ""
                                        }`}
                                ></span>
                                {label}
                            </React.Fragment>
                        ))}
                    </div>

                    <div><strong>6. Hướng điều trị và các chế độ tiếp theo</strong></div>
                    {huong_dieu_tri_tiep_theo ? (
                        <div className='mb-4'>{huong_dieu_tri_tiep_theo}</div>
                    ) : (
                        <>
                            <div className='line' />
                            <div className='line' />
                            <div className='line' />
                            <div className='line mb-4' />
                        </>
                    )}


                    <div className="signature-section">
                        <div className="signature-col" />
                        <div className="signature-col">
                            {/* <div className="date-line">Ngày ..... tháng ..... năm 20.....</div> */}
                            <div className='date-line'>Ngày {formatVietnameseDate(moment().format('DD/MM/YYYY'))}</div>
                            <div className="sign-label">Bác sĩ điều trị</div>
                            <div className="sign-note">(Ký, ghi rõ họ tên)</div>
                        </div>
                    </div>
                </div>

                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 2cm;
                            /* top, right, bottom, left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            html,
                            body {
                                margin: 0 auto;
                                padding: 0;
                            }

                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 12pt;
                                line-height: 1.5;
                                color: #000;
                               /*  width: 210mm;
                                border: 1px solid #dedede; */
                            }
                        }
                        .print-container {
                            max-width: 800px;
                            margin: 0 auto;
                            padding: 0;
                            position: relative;
                        }

                        .print-page {
                            position: relative;
                            width: 100%;
                            min-height: calc(297mm - 30mm);
                            page-break-after: always;
                        }

                        .print-container .header {
                            display: grid;
                            grid-template-columns: 1fr 1fr 1fr;
                            /* 3 cột bằng nhau */
                            align-items: start;
                            column-gap: 4mm;
                            position: relative;
                            margin-bottom: 4mm;
                        }

                        .print-container .header-left {
                            font-size: 12pt;
                            line-height: 1.4;
                        }

                        .print-container .header-center {
                            text-align: center;
                        }

                        .print-container .header-right {
                            text-align: right;
                            font-size: 11pt;
                            font-weight: bold;
                            padding-top: 2mm;
                        }

                        .print-container .title {
                            margin: 0;
                            font-weight: 700;
                            line-height: 1.35;
                            font-size: 14pt;
                        }

                        .print-container .tiny-box {
                            /* ô vuông nhỏ ở góc phải trên cùng (theo ảnh) */
                            display: inline-block;
                            width: 4mm;
                            height: 4mm;
                            border: 0.3pt solid #000;
                        }

                        .print-container .ms-code {
                            /* MS: BA-18 đặt CHÍNH XÁC góc phải */
                            position: absolute;
                            top: 0;
                            /* bám sát mép lề trên của trang (sau margin @page) */
                            right: 0;
                            /* bám sát mép lề phải của trang */
                            font-size: 11pt;
                            font-weight: 700;
                        }

                        /* ===== Khối chung ===== */
                        .print-container h3 {
                            margin: 6mm 0 2.5mm;
                            font-size: 12pt;
                            font-weight: 700;
                            text-transform: uppercase;
                        }

                        .print-container .section {
                            margin: 1.5mm 0;
                        }

                        .print-container .info-grid {
                            display: grid;
                            grid-template-columns: 1fr 1fr;
                            /* hai cột bằng nhau */
                            column-gap: 10mm;
                        }

                        .print-container .info-grid .col {
                            display: flex;
                            flex-direction: column;
                            /* gap: 1.5mm; */
                        }

                        .print-container .info-item {
                            display: flex;
                            align-items: baseline;
                            flex-wrap: wrap;
                        }

                        .print-container .info-item span {
                            display: inline-block;
                        }

                        .print-container .info-item .label {
                            white-space: nowrap;
                            margin-right: 2mm;
                        }

                        .print-container .underline {
                            display: inline-block;
                            /* border-bottom: 0.3pt dotted #000; */
                            min-width: 20mm;
                            height: 1.3em;
                        }

                        .print-container .checkbox {
                            display: inline-block;
                            width: 3.5mm;
                            height: 3.5mm;
                            border: 0.35pt solid #000;
                            vertical-align: middle;
                            text-align: center;
                            margin: 0 2mm 0 4mm;
                            position: relative;
                        }

                       .print-container .checkbox.checked::after {
                                content: "✓";
                                position: absolute;
                                top: 48%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                font-size: 12pt; 
                                font-weight: bold;
                                line-height: 1;
                        }

                        .print-container .text-uppercase {
                            text-transform: uppercase;
                        }

                        .print-container .text-italic {
                            font-style: italic;
                        }

                        .print-container .display-inline {
                            display: inline-block;
                        }

                        .print-container .line {
                            height: 5mm;
                            border-bottom: 0.3pt dotted #000;
                            margin: 0.8mm 0;
                        }

                        .print-container .exam-section {
                            display: grid;
                            grid-template-columns: 1fr 60mm;
                            /* trái chiếm phần mô tả, phải cố định 60mm */
                            column-gap: 5mm;
                            align-items: start;
                            position: relative;
                        }

                        .print-container .vitals {
                            border: 0.3pt solid #000;
                            padding: 2mm 3mm;
                            font-size: 11pt;
                            line-height: 1.5;
                        }

                        .print-container .vitals p {
                            margin: 0;
                        }

                        .print-container .vitals-label {
                            display: inline-block;
                            min-width: 22mm;
                        }

                        /* điều chỉnh mm nếu cần khớp bản in của bạn */

                        /* Bảng quá trình điều trị */
                        .print-container table {
                            border-collapse: collapse;
                            width: 100%;
                        }

                        .print-container .tb {
                            margin-top: 3mm;
                        }

                        .print-container .tb th,
                        .print-container .tb td {
                            border: 0.3pt solid #000;
                            padding: 2mm;
                            font-size: 11.5pt;
                            height: 8mm;
                        }

                        /* margin-top */
                        .print-container .mt-0 {
                            margin-top: 0 !important;
                        }

                        .print-container .mt-1 {
                            margin-top: 1mm !important;
                        }

                        .print-container .mt-2 {
                            margin-top: 2mm !important;
                        }

                        .print-container .mt-3 {
                            margin-top: 3mm !important;
                        }

                        .print-container .mt-4 {
                            margin-top: 4mm !important;
                        }

                        .print-container .mt-5 {
                            margin-top: 5mm !important;
                        }

                        .print-container .mt-6 {
                            margin-top: 6mm !important;
                        }

                        .print-container .mt-8 {
                            margin-top: 8mm !important;
                        }

                        .print-container .mt-10 {
                            margin-top: 10mm !important;
                        }

                        /* margin-bottom */
                        .print-container .mb-0 {
                            margin-bottom: 0 !important;
                        }

                       .print-container  .mb-1 {
                            margin-bottom: 1mm !important;
                        }

                        .print-container .mb-2 {
                            margin-bottom: 2mm !important;
                        }

                        .print-container .mb-3 {
                            margin-bottom: 3mm !important;
                        }

                       .print-container  .mb-4 {
                            margin-bottom: 4mm !important;
                        }

                        .print-container .mb-5 {
                            margin-bottom: 5mm !important;
                        }

                        .print-container .mb-6 {
                            margin-bottom: 6mm !important;
                        }

                        .print-container .mb-8 {
                            margin-bottom: 8mm !important;
                        }

                        .print-container .mb-10 {
                            margin-bottom: 10mm !important;
                        }

                        /* margin-left */
                        .print-container .ml-0 {
                            margin-left: 0 !important;
                        }

                       .print-container  .ml-1 {
                            margin-left: 1mm !important;
                        }

                        .print-container .ml-2 {
                            margin-left: 2mm !important;
                        }

                        .print-container .ml-3 {
                            margin-left: 3mm !important;
                        }

                        .print-container .ml-4 {
                            margin-left: 4mm !important;
                        }

                        .print-container .ml-5 {
                            margin-left: 5mm !important;
                        }

                        .print-container .ml-6 {
                            margin-left: 6mm !important;
                        }

                        .print-container .ml-8 {
                            margin-left: 8mm !important;
                        }

                        .print-container .ml-10 {
                            margin-left: 10mm !important;
                        }

                        /* margin-right */
                        .print-container .mr-0 {
                            margin-right: 0 !important;
                        }

                        .print-container .mr-1 {
                            margin-right: 1mm !important;
                        }

                        .print-container .mr-2 {
                            margin-right: 2mm !important;
                        }

                        .print-container .mr-3 {
                            margin-right: 3mm !important;
                        }

                        .print-container .mr-4 {
                            margin-right: 4mm !important;
                        }

                        .print-container .mr-5 {
                            margin-right: 5mm !important;
                        }

                        .print-container .mr-6 {
                            margin-right: 6mm !important;
                        }

                        .print-container .mr-8 {
                            margin-right: 8mm !important;
                        }

                        .print-container .mr-10 {
                            margin-right: 10mm !important;
                        }

                        /* margin x và y tổng hợp */
                        .print-container .mx-auto {
                            margin-left: auto !important;
                            margin-right: auto !important;
                        }

                        .print-container .mx-2 {
                            margin-left: 2mm !important;
                            margin-right: 2mm !important;
                        }

                        .print-container .my-2 {
                            margin-top: 2mm !important;
                            margin-bottom: 2mm !important;
                        }

                        .print-container .my-4 {
                            margin-top: 4mm !important;
                            margin-bottom: 4mm !important;
                        }

                        .print-container .my-6 {
                            margin-top: 6mm !important;
                            margin-bottom: 6mm !important;
                        }

                        .print-container .signature-section {
                            display: grid;
                            grid-template-columns: 1fr 1fr;
                            /* 2 cột bằng nhau */
                            margin-top: 8mm;
                            text-align: center;
                            column-gap: 10mm;
                            font-size: 11.5pt;
                            line-height: 1.5;
                        }

                        .print-container .signature-col {
                            width: 100%;
                        }

                        .print-container .signature-col .date-line {
                            margin-bottom: 2mm;
                        }

                        .print-container .signature-col .sign-label {
                            font-weight: bold;
                        }

                        .print-container .signature-col .sign-note {
                            font-style: italic;
                            font-size: 11pt;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintCustomerProfile;
